import { CheckList } from "shared/components/CheckList";
import { LARGE } from "shared/utils/constants";
import { MaxWidth } from "shared/components/MaxWidth";
import { SrcSet } from "shared/components/SrcSet";
import styles from "./LandingHero.module.css";

export const LandingHero = ({ title, listTitle, list, intro, image }) => (
  <div className={styles.container}>
    <MaxWidth size={LARGE}>
      <div className={styles.grid}>
        <div className={styles.content}>
          <h1>{title}</h1>
          {intro && <p>{intro}</p>}
          {listTitle && <h2>{listTitle}</h2>}
          {list && <CheckList items={list} />}
        </div>

        {image && (
          <div className={styles.image}>
            <SrcSet
              alt={image.alt}
              sizes={[
                { minWidth: 1200, width: 640 },
                { minWidth: 1100, width: 530 },
                { minWidth: 1000, width: 480 },
                { minWidth: 900, width: 440 },
                { minWidth: 850, width: 390 },
                { minWidth: 800, width: 360 },
                { minWidth: 768, width: 320 },
                { minWidth: 1, width: 240 },
              ]}
              src={image.url}
            />
          </div>
        )}
      </div>
    </MaxWidth>
  </div>
);
